const styleSheet = () => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    width: '100vw',
    overflow: 'hidden',
  },
  sideBarHider: {
    width: '331px',
    // overflowY: "hidden",
    position: 'relative',
    transition: 'all 600ms',
    transitionTimingFunction: 'cubic-bezier(.28,.73,.38,1.02)',
    display: (props: any) => (props.showSidebar ? 'block' : 'none'),
  },
  sideBarHiderClosed: {
    width: '60px',
  },
  simplebar: {
    '& .simplebar-track.simplebar-vertical': {
      marginTop: '120px',
    },
  },
  sideBarChild: {
    opacity: (props: any) => (props.isOpen ? 1 : 0),
    transition: 'all 300ms',
    padding: '0 22px 0 32px',
  },
  funnel: {
    cursor: 'pointer',
  },
  funnelIcon: {
    position: 'relative',
    top: '2px',
    left: '-1px',
    '& path': {
      fill: '#065fe5',
    },
  },
  sideBarClosed: {
    transform: 'translateX(-265px)',
  },
  title: {
    color: '#051D39',
    fontSize: '14px',
    textTransform: 'uppercase',
    marginLeft: '10px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    padding: '47px 15px 30px 32px',
  },
  fixedHeaderContainer: {
    position: 'sticky',
    top: 0,
    right: 0,
    left: 0,
    backgroundColor: 'white',
    zIndex: 30,
    width: '330px',
    height: '120px',
  },
  iconHolder: {
    backgroundColor: 'transparent',
    width: '36px',
    height: '36px',
    borderRadius: '100%',
    border: '1.57px solid #E1EDFB',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 'auto',
    cursor: 'pointer',
  },
  arrow: {
    left: '-1px',
    position: 'relative',
    top: '1px',
  },
  mainContent: {
    overflowX: 'hidden',
    // overflowY: "scroll",
    margin: '0 auto',
    transition: 'all 600ms',
    transitionTimingFunction: 'cubic-bezier(.28,.73,.38,1.02)',
  },
  '@media screen and (max-width: 1450px)': {
    mainContent: {
      // overflowX: "scroll"
    },
  },
  clearAllButton: {
    color: '#085FE5',
    fontFamily: "'Museo Sans', sans-serif",
    fontSize: '12px',
    fontWeight: 500,
    letterSpacing: 0,
    lineHeight: '14px',
    marginLeft: '10px',
    background: 'inherit',
    border: 'none',
    cursor: 'pointer',
    '&:focus': {
      outline: 'dotted 1px gray',
    },
  },
  error: {
    margin: '-22px 0px 14px 56px',
    height: '15px',
    width: '158px',
    color: '#FF6969',
    fontFamily: "'Museo Sans', sans-serif",
    fontSize: '12px',
    fontWeight: '500',
    letterSpacing: '0',
    lineHeight: '15px',
  },
  hidden: {
    visibility: 'hidden',
  },
});

export default styleSheet;
